import { useMetadataQuery } from "@/hooks/metadata";
import SSRIcon from "@ingka/ssr-icon";
import noticeCircle from "@ingka/ssr-icon/paths/notice-circle";
import notVisiblePath from "@ingka/ssr-icon/paths/visibility-hide";
import visiblePath from "@ingka/ssr-icon/paths/visibility-show";
import Text from "@ingka/text";
import { AssetDto } from "generated";
import { useMemo } from "react";
import { getMetadataEntries } from "./utils";
import { MetadataEntry } from "./types";
import { ProducedByDto } from "@/hooks/types";

type Props = {
  assets: AssetDto[];
  handleChangeVisible: (metadataField: string) => void;
  visibility: string[];
};

export const AdminAssetsOverview = ({
  assets,
  handleChangeVisible,
  visibility,
}: Props) => {
  const {
    data: { producers, producedBy, bynder, documentContentTypes } = {
      producers: [],
      producedBy: {} as ProducedByDto,
    },
  } = useMetadataQuery();
  const metadataSections: MetadataEntry[] = useMemo(
    () =>
      getMetadataEntries(
        assets,
        producers,
        producedBy,
        bynder,
        documentContentTypes,
      ),
    [assets, producers, producedBy, bynder, documentContentTypes],
  );
  return (
    <div className="col-span-2 grid grid-cols-3">
      {metadataSections.map((section) => {
        return (
          <div
            key={section.id}
            className="mr-space75 mt-space150 flex items-start"
          >
            <button
              type="button"
              className="me-space25 border-0 bg-transparent p-0 leading-none"
              onClick={() => handleChangeVisible(section.id)}
              aria-label={
                visibility.includes(section.id)
                  ? `Show ${section.title}`
                  : `Hide ${section.title}`
              }
            >
              <SSRIcon
                paths={
                  visibility.includes(section.id) ? notVisiblePath : visiblePath
                }
              />
            </button>
            <div>
              <div className="flex items-center">
                <Text headingSize="xs">{section.title}</Text>
                {section.showWarning && (
                  <SSRIcon
                    paths={noticeCircle}
                    className="ms-space25 text-red-500"
                    aria-label={`Warning: ${section.title} has a validation issue`}
                    ariaHidden={false}
                  />
                )}
              </div>
              {!section.hideValues &&
                Object.entries(section.entries).map(([key, value]) => (
                  <Text key={key} bodySize="s">
                    {key} ({value})
                  </Text>
                ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};
